export default function () {
  return {
    insuranceRight: null,
    isLoadingInsuranceRight: false,
    isSavingInsuranceRight: false,
  };
}
